// Interfaces
import { IBaseHeaderNavigations } from './interfaces'

// Constant
import {
  HOME_URL,
  ABOUT_US_URL,
  CERTIFICATION_URL,
  ASSESSOR_URL,
  TUK_URL,
  GALLERY_URL,
  CONTACT_US_URL,
  NEWS_URL,
} from 'constant/url.constant'

const HOME: IBaseHeaderNavigations[] = [
  {
    id: 'HOME',
    title: 'app.home',
    route: HOME_URL.INDEX,
    children: [],
  },
]

const ABOUT_US: IBaseHeaderNavigations[] = [
  {
    id: 'ABOUT_US',
    title: 'app.aboutUs',
    route: ABOUT_US_URL.INDEX,
    children: [],
  },
]

const CERTIFICATIONS: IBaseHeaderNavigations[] = [
  {
    id: 'CERTIFICATIONS',
    title: 'app.certification',
    route: CERTIFICATION_URL.INDEX,
    children: [],
  },
]

const ASSESSOR: IBaseHeaderNavigations[] = [
  {
    id: 'ASSESSOR',
    title: 'app.assessor',
    route: ASSESSOR_URL.INDEX,
    children: [],
  },
]

const TUK: IBaseHeaderNavigations[] = [
  {
    id: 'TUK',
    title: 'app.tuk',
    route: TUK_URL.INDEX,
    children: [],
  },
]

const GALLERY: IBaseHeaderNavigations[] = [
  {
    id: 'GALLERY',
    title: 'app.gallery',
    route: GALLERY_URL.INDEX,
    children: [],
  },
]

const CONTACT_US: IBaseHeaderNavigations[] = [
  {
    id: 'CONTACT_US',
    title: 'app.contactUs',
    route: CONTACT_US_URL.INDEX,
    children: [],
  },
]

const NEWS: IBaseHeaderNavigations[] = [
  {
    id: 'NEWS',
    title: 'news.news',
    route: NEWS_URL.INDEX,
    children: [],
  },
]

const navigations: IBaseHeaderNavigations[] = [
  ...HOME,
  ...ABOUT_US,
  ...CERTIFICATIONS,
  ...ASSESSOR,
  ...TUK,
  ...GALLERY,
  ...CONTACT_US,
  ...NEWS,
]

export { navigations }
